export default __webpack_public_path__ + "static/media/persistence.65f000e8.mp4";